import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useQuery } from 'react-query';
import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import {
  Accordion, AccordionSummary, AccordionDetails, Grid
} from '@material-ui/core';
import moment from 'moment';
import 'moment/locale/hu';

import { STATUS } from '../../../utils/const';
import { addAlert } from '../../../actions/alerts.action';
import { getObjectiveRelationsByObjective } from '../../../api/objective/objectiveRelation.api';
import ObjectiveDialog from '../Dialog';
import ObjectiveSummary from './ObjectiveSummary';
import ObjectiveTabs from './Tabs';
import DeleteObjectiveModal from '../DeleteObjectiveModal';

const useStyles = makeStyles (theme => ({
  root: {
    width: '100%'
  },
  expansionPanel: {
    borderBottom: '1px solid #DFE0EB'
  },
  detailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  }
}));

const ObjectiveItem = ({ objective = {}, onSubmitSuccess }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up('md'));

  moment.locale('hu');

  const [ isPanelOpened, setPanelOpen ] = useState(false);
  const [ updateDialogOpen, setUpdateDialogOpen ] = useState(false);
  const [ deleteDialogOpen, setDeleteDialogOpen ] = useState(false);

  const employeeIdOfCurrentUser = objective.employee_id;

  const isEditable = objective.status !== STATUS.COMPLETED &&
    objective.status !== STATUS.FAILED && objective.employee_id === objective.proposed_by;

  const isDeletable = objective.status === STATUS.PROPOSED &&
    objective.employee_id === objective.proposed_by;

  const objectiveRelationsQuery = useQuery(
    [ 'objectiveRelations', objective.id ],
    async () => {
      const { data } = await getObjectiveRelationsByObjective({
        objectiveId: objective.id
      });
      return data;
    },
    {
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );
  const objectiveRelations = objectiveRelationsQuery.data ?? [];

  return (
    <div className={ classes.root }>
      <Accordion
        square={ true }
        className={ classes.expansionPanel }
        expanded={ isPanelOpened }
        elevation={ md ? 0 : 1 }
      >
        <AccordionSummary
          aria-controls='panel1a-content'
          id={ objective.objective_id }
          onClick={ () => setPanelOpen(!isPanelOpened) }
        >
          <ObjectiveSummary
            objective={ objective }
            setUpdateDialogOpen={ setUpdateDialogOpen }
            setDeleteDialogOpen={ setDeleteDialogOpen }
            isEditable={ isEditable }
            isDeletable={ isDeletable }
            isPanelOpened={ isPanelOpened }
            onSubmitSuccess={ onSubmitSuccess }
          />
        </AccordionSummary>
        <AccordionDetails className={ classes.detailsContainer }>
          {
            isPanelOpened &&
            <Grid container direction={ 'column' } >
              <ObjectiveTabs
                objectiveRelations={ objectiveRelations }
                objective={ objective }
                onSubmitSuccess={ onSubmitSuccess }
              />
            </Grid>
          }
        </AccordionDetails>
        <ObjectiveDialog
          open={ updateDialogOpen }
          handleClose={ () => setUpdateDialogOpen(false) }
          objectiveItem={ objective }
          employeeIdOfCurrentUser={ employeeIdOfCurrentUser }
          onSubmitSuccess={ onSubmitSuccess }
        />
        <DeleteObjectiveModal
          open={ deleteDialogOpen }
          onClose={ () => setDeleteDialogOpen(false) }
          objective={ objective }
          onSuccess={ onSubmitSuccess }
        />
      </Accordion>
    </div>
  );
};

export default ObjectiveItem;
